import React from "react";
import { useLocation } from "react-router-dom";
import { MaliStripe } from "./MaliStripe";

// Routes that benefit from a full-bleed desktop layout (admin command-center,
// agency dispatch dashboard) — they break out of the phone shell on >= md screens.
const FULL_BLEED = ["/admin", "/admin/agency", "/agence/carte"];

export const PhoneShell = ({ children }) => {
  const { pathname } = useLocation();
  const fullBleed = FULL_BLEED.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  // iOS Safari's `100vh` is sized to the LARGEST possible viewport (toolbar
  // collapsed), which can leave real content clipped below the fold when
  // the toolbar is actually showing. `100dvh` tracks the CURRENT visible
  // viewport instead, fixing that without any visual change on browsers
  // that already behave correctly. Central Admin dashboard is explicitly
  // excluded — it already works well on iPad and must not change.
  const isCentralAdmin = pathname.startsWith("/admin") && !pathname.startsWith("/admin/agency");
  const heightClass = isCentralAdmin ? "min-h-screen" : "min-h-[100dvh]";
  return (
    <div className={`${heightClass} w-full bg-muted flex items-stretch justify-center`} data-testid="app-shell">
      <div
        className={`phone-shell relative w-full ${heightClass} bg-background shadow-[0_0_60px_rgba(0,0,0,0.1)] overflow-hidden flex flex-col ${
          isCentralAdmin ? "" : "pt-[env(safe-area-inset-top)]"
        } ${
          fullBleed
            ? "max-w-full md:max-w-7xl pb-0"
            : "max-w-md pb-[calc(72px+env(safe-area-inset-bottom))]"
        }`}
      >
        <MaliStripe thick />
        {children}
      </div>
    </div>
  );
};
